import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useSectors } from '@/hooks/v1';
import { SectorSelect } from '@/components/ui/Inputs/SectorSelect';
import { useApplicationContext } from '@/context/v1/Application/context';
import { LINE_FIELD, SECTOR_FIELD, WORKSTATION_FIELD } from './constants';
import { FieldFormItem } from './styles';

const { useFormInstance, useWatch } = Form;

export function Sector(): JSX.Element {
	const form = useFormInstance();
	const { company, organization } = useApplicationContext();

	const sectorId = useWatch(SECTOR_FIELD, form);

	const {
		data: sectors,
		isLoading,
		isFetching,
		isError
	} = useSectors({
		organizationId: organization?.id,
		companyId: company?.id
	});

	function handleSelectSector(id?: string): void {
		form.setFieldValue(SECTOR_FIELD, id);
		form.setFieldValue(LINE_FIELD, undefined);
		form.setFieldValue(WORKSTATION_FIELD, undefined);
	}

	function handleClearSector(): void {
		handleSelectSector(undefined);
	}

	const isDisabled = isLoading || isFetching || isError;

	return (
		<FieldFormItem name={SECTOR_FIELD} label={I18n.get('Sector')} labelCol={{ span: 24 }}>
			<SectorSelect
				sectors={sectors}
				sectorId={sectorId}
				loading={isFetching}
				disabled={isDisabled}
				fieldName={SECTOR_FIELD}
				allowCreation={false}
				handleClearSector={handleClearSector}
				handleSelectSector={handleSelectSector}
			/>
		</FieldFormItem>
	);
}
